<template>
  <v-app>
    <v-card>
      <v-card-title class="headline justify-center">Pacientes</v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <v-form @submit.prevent="searchPatients" id="form-patient">
              <v-container>
                <v-row>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="formPatient.name"
                      label="Nombre"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
              <v-btn type="submit" color="success" class="mr-4">
                <v-icon>mdi-magnify</v-icon>Buscar
              </v-btn>
            </v-form>
          </v-col>
        </v-row>
        <Table
          v-if="Object.keys(patients).length"
          :patients="patients"
          @search-patients="searchPatients"
        />
      </v-card-text>
    </v-card>
    <New v-if="dialog" :openModal="dialog" @close-modal="dialog = false" />
    <v-fab-transition>
      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn
            fab
            fixed
            bottom
            right
            color="primary"
            dark
            v-on="on"
            @click="dialog = !dialog"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </template>
        <span>Nuevo paciente</span>
      </v-tooltip>
    </v-fab-transition>
  </v-app>
</template>

<script>
import * as moment from "moment";
import Swal from "sweetalert2";
import Table from "./Table";
import New from "./New";

export default {
  components: { Table, New },
  data() {
    return {
      minDate: moment().add(1, "day").format("YYYY-MM-DD"),
      formPatient: {
        name: "",
      },
      formAssignDate: {
        date: "",
        time: "",
      },
      dateModal: false,
      dateAssignModal: false,
      timeAssignModal: false,
      patients: [],
      headers: [
        {
          text: "Nombre",
          value: "name",
        },
        {
          text: "Edad",
          value: "age",
        },
        {
          text: "Altura",
          value: "height",
        },
        {
          text: "Opciones",
          allowedDates: (val) => ![5, 6].includes(new Date(val).getDay()),
          value: "options",
          sortable: false,
        },
      ],
      patient: {},
      patientData: {},
      measure: "",
      dialog: false,
    };
  },
  methods: {
    allowedDates: (val) => ![6].includes(new Date(val).getDay()),
    getIcon(value) {
      if (value > 0) {
        return "chevron-up";
      }
      if (value < 0) {
        return "chevron-down";
      }
      if (value == 0) {
        return "equal";
      }
    },
    searchPatients() {
      this.openLoader();
      window.setTimeout(() => {
        const request = this.sendRequest(
          this.$store.state.apiUrl + "catalogs/patients",
          this.formPatient
        );
        request
          .then(({ data }) => {
            this.patients = data;
          })
          .finally(() => this.closeLoader());
      }, 200);
    },
    editPatient(patient) {
      this.openLoader();
      window.setTimeout(() => {
        const request = this.sendRequest(
          this.$store.state.apiUrl + "catalogs/patients/" + patient.id
        );
        request
          .then(({ data }) => {
            this.formEditPatient = data;
            this.dialogEditPatient = true;
          })
          .finally(this.closeLoader());
      }, 200);
    },
    registerMeasures(patient) {
      this.formMeasuresPatient.patient_id = patient.id;
      this.dialogRegisterMeasures = true;
    },
    showTracing(patient) {
      this.openLoader();
      window.setTimeout(() => {
        const request = this.sendRequest(
          this.$store.state.apiUrl + "catalogs/patients/" + patient.id
        );
        request
          .then(({ data }) => {
            this.patient = data;
            this.dialogTracingPatient = true;
          })
          .finally(this.closeLoader());
      }, 200);
    },
    savePatient() {
      this.openLoader();
      window.setTimeout(() => {
        const request = this.sendRequest(
          this.$store.state.apiUrl +
            "catalogs/patients/" +
            this.formEditPatient.id,
          this.formEditPatient,
          "PUT"
        );
        request
          .then(({ message }) => {
            this.showSuccessMessage(message);
            this.dialogEditPatient = false;
            this.searchPatients();
          })
          .finally(this.closeLoader());
      }, 200);
    },
    saveMeasures() {
      this.openLoader();
      window.setTimeout(() => {
        const request = this.sendRequest(
          this.$store.state.apiUrl +
            "catalogs/patients/" +
            this.formMeasuresPatient.patient_id +
            "/measures",
          this.formMeasuresPatient,
          "POST"
        );
        request
          .then(({ message }) => {
            this.showSuccessMessage(message);
            this.dialogRegisterMeasures = false;
            this.searchPatients();
            this.clearForm(this.formMeasuresPatient);
          })
          .finally(this.closeLoader());
      }, 200);
    },
    assignDate(patient) {
      this.openLoader();
      window.setTimeout(() => {
        this.patientData = patient;
        this.dialogAssignDatePatient = true;
        this.closeLoader();
      }, 200);
    },
    saveAssignDate() {
      this.openLoader();
      window.setTimeout(() => {
        const request = this.sendRequest(
          this.$store.state.apiUrl +
            "catalogs/patients/" +
            this.patientData.id +
            "/dates",
          this.formAssignDate,
          "POST"
        );
        request
          .then(({ message }) => {
            this.showSuccessMessage(message);
            this.dialogAssignDatePatient = false;
            this.searchPatients();
          })
          .finally(this.closeLoader());
      }, 200);
    },
    checkAssistance(patient) {
      this.openLoader();
      window.setTimeout(() => {
        const request = this.sendRequest(
          this.$store.state.apiUrl +
            "catalogs/patients/" +
            patient.id +
            "/assistance",
          {},
          "POST"
        );
        request
          .then(({ message }) => {
            this.showSuccessMessage(message);
            this.searchPatients();
          })
          .finally(this.closeLoader());
      }, 200);
    },
    showPDF(measure) {
      this.measure = "http://localhost:81/api/formats/measures/" + measure.id;
      this.dialogPdfTracing = true;
    },
    remove(patient) {
      Swal.fire({
        title: "¿Está seguro?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          this.openLoader();
          window.setTimeout(() => {
            const request = this.sendRequest(
              this.$store.state.apiUrl + "catalogs/patients/" + patient.id,
              {},
              "DELETE"
            );
            request
              .then(() => {
                this.showSuccessMessage("Paciente eliminado correctamente");
                this.searchPatients();
              })
              .finally(this.closeLoader());
          }, 200);
        }
      });
    },
  },
};
</script>
